module.exports = __webpack_public_path__ + "img/result-bg.5f36938b.png";